import { render, staticRenderFns } from "./ImCascader.vue?vue&type=template&id=536a028c"
import script from "./ImCascader.vue?vue&type=script&lang=js"
export * from "./ImCascader.vue?vue&type=script&lang=js"
import style0 from "./ImCascader.vue?vue&type=style&index=0&id=536a028c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports